import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const dmsDocumentsUrlQuery: TypedDocumentNode<
    Pick<GQL.IQuery, "dmsDocumentsUrl">,
    GQL.IQueryDmsDocumentsUrlArgs
> = gql`
    query dmsDocumentsUrl($input: IDsCompanyIDInput!) {
        dmsDocumentsUrl(input: $input) {
            id
            url
            expiresAt
        }
    }
`;
